import { Card, CardContent } from "@/components/ui/card";
import { Image, View } from "@/components/ui";
import {
  Typography,
  type TypographyVariants,
} from "@/components/shared/typography";

type TypographyColor = keyof TypographyVariants["color"];

export interface TodoCardProps {
  onClick: () => void;
  image: string;
  title: string;
  desc: string;
  descColor?: TypographyColor | null;
  titleColor?: TypographyColor | null;
}

export const TodoCard = ({
  onClick,
  image,
  title,
  desc,
  descColor,
  titleColor,
}: TodoCardProps) => {
  return (
    <Card className="w-full cursor-pointer" onClick={onClick}>
      <CardContent className="flex flex-row items-center gap-3 px-4 py-3">
        <View className="mr-auto flex flex-col gap-0.5">
          <Typography
            variant="body-sm"
            color={descColor ?? "foreground-intermediate"}
            className="whitespace-nowrap"
          >
            {desc}
          </Typography>
          <Typography
            variant="body-md"
            numberOfLines={1}
            color={titleColor ?? "foreground-default"}
          >
            {title}
          </Typography>
        </View>
        <Image src={image} alt={title} width={40} height={40} />
      </CardContent>
    </Card>
  );
};
